const application = {
    state: {
      stage: 0,
      isPC: 0,
      authorityRoute:'/parent'
  
    },
    mutations: {
      setIsPC: (state, isPC) => {
        state.isPC = isPC
      },
      setStage: (state, stage) => {
        state.stage = stage
      },
      setAuthorityRoute: (state, authorityRoute) => {
        state.authorityRoute = authorityRoute
      },
    },
    actions: {
      setIsPC({ commit },isPC) {
        commit('setIsPC',isPC)
      },
      setStage({ commit },stage) {
        commit('setStage',stage)
      },
      setAuthorityRoute({ commit },authorityRoute) {
        commit('setAuthorityRoute',authorityRoute)
      },
    }
}

export default application